import { systemsColors } from "Pages/Admin/ClientMap/Components/systemsColors";

import styles from "Pages/Admin/ClientMap/Components/Legend/Legend.module.css";
import { Button } from "reactstrap";

interface IProps {
    filter: string;
    isShown: (
        filter: string,
        system: string,
        possibleSystems: string[]
    ) => boolean;
    onSetFilter: (system: string) => void;
}

export default function Legend({ filter, isShown, onSetFilter }: IProps) {
    const handleClick = (system: string) => {
        if (filter === system) {
            onSetFilter("");
        } else {
            onSetFilter(system);
        }
    };

    return (
        <div className={styles.box}>
            <div>Legend</div>
            {systemsColors.map((s) => (
                <Button
                    key={s.name}
                    className={styles.button}
                    color={s.color}
                    onClick={() => handleClick(s.name)}
                    style={
                        filter !== "" &&
                        isShown(
                            filter,
                            s.name,
                            systemsColors.map((s) => s.name)
                        )
                            ? {
                                  filter: "brightness(0.6)",
                                  boxShadow: "0 0 2px 1px gray",
                              }
                            : {}
                    }
                >
                    {s.displayName}
                </Button>
            ))}
        </div>
    );
}
